import axios from "axios";

let customerSvc = process.env.VUE_APP_COMPANY_API_URL;
let companyRoot = process.env.VUE_APP_COMPANY_USER_ROOT;

axios.defaults.headers.common["api_key"] =
	process.env.VUE_APP_CARD_USER_API_KEY;

const customerAxiosInstance = axios.create({
	baseURL: customerSvc,
});

export default {
	customerService: {
		confirmCustomerData(url, customerData, token) {
			return customerAxiosInstance.put(url, customerData, {
				headers: {
					Authorization: "Bearer " + btoa(token),
					"Content-Type": "application/json",
				},
			});
		},

		searchOffers(searchParams, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/offers/search" +
				searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		addNewOffer(userid, formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/offers",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		updateOffer(offer, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/offers/" + offer.id,
				offer,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		transferOffers(offerTransfer, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/offers/transfer",
				offerTransfer,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		searchPersons(searchParams, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/persons/search" +
				searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		addFriend(userid, formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/users/" + userid + "/friends",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		updatePersonInfo(userid, person, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/users/" + userid + "/persons/" + person.id,
				person,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		deleteUser(user, token) {
			return customerAxiosInstance.delete(
				companyRoot + "/v1/users/" + user.id,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		updateUserInfo( user, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/users/" + user.id ,
				user,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		sendFeedbackMail(formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/users/" + formData.code + "/send_feedback",
				{
					description: formData.description,
				},
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		deleteOfferForCompany(offerId, token) {
			return customerAxiosInstance.delete(
				companyRoot + "/v1/offers/" + offerId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		
		getOfferDetails(offerId, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/offers/" +
				offerId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		getMessages(formData, token) {
			return customerAxiosInstance.get(
				companyRoot + "/v2/app_messages" + formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		markMessageAsRead(message, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v2/app_messages/" + message.id,
				message,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		searchCompany(searchParams, token) {
			return customerAxiosInstance.get(
				companyRoot + "/v1/financiers/search" + searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
	},
};
